/**
 * Hydrate product-card / slider photos as they approach the viewport.
 * Off-screen imgs use data-ed-src (no network) until swipe/scroll.
 */
(function () {
  function markGalleryLoaded(img) {
    var gallery = img && img.closest && img.closest('.card-gallery');
    if (gallery) gallery.classList.add('is-loaded');
  }

  function hydrate(img) {
    if (!(img instanceof HTMLImageElement)) return;
    if (img.dataset.edHydrated === '1') return;

    var src = img.getAttribute('data-ed-src');
    var srcset = img.getAttribute('data-ed-srcset');
    var sizes = img.getAttribute('data-ed-sizes');
    if (!src && !srcset) {
      markGalleryLoaded(img);
      return;
    }

    img.dataset.edHydrated = '1';
    if (sizes) img.setAttribute('sizes', sizes);
    if (srcset) img.setAttribute('srcset', srcset);
    if (src) img.setAttribute('src', src);

    if (img.complete && img.naturalWidth > 0) {
      markGalleryLoaded(img);
    } else {
      img.addEventListener('load', function () {
        markGalleryLoaded(img);
      }, { once: true });
      img.addEventListener('error', function () {
        markGalleryLoaded(img);
      }, { once: true });
    }
  }

  function getIo() {
    if (window.__edLazyIo) return window.__edLazyIo;
    if (!('IntersectionObserver' in window)) return null;

    window.__edLazyIo = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          hydrate(entry.target);
          window.__edLazyIo.unobserve(entry.target);
        });
      },
      { root: null, rootMargin: '280px 160px', threshold: 0.01 }
    );
    return window.__edLazyIo;
  }

  function observe(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var images = scope.querySelectorAll('img[data-ed-src]:not([data-ed-hydrated="1"])');
    if (!images.length) return;

    var io = getIo();
    if (!io) {
      images.forEach(hydrate);
      return;
    }

    images.forEach(function (img) {
      io.observe(img);
    });
  }

  function markEagerGalleries() {
    document.querySelectorAll('.card-gallery img.product-media__image:not([data-ed-src])').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        markGalleryLoaded(img);
      } else {
        img.addEventListener('load', function () {
          markGalleryLoaded(img);
        }, { once: true });
      }
    });
  }

  function init() {
    observe(document);
    markEagerGalleries();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
